import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLDivElement
  Args: {
    text: string
  }
}

export const HRText: TOC<Signature> = <template>
  <div class="flex flex-row items-center" ...attributes>
    <hr class="bg-dusty-black-200 m-0 h-px grow border-0" />
    <span class="px-4">{{@text}}</span>
    <hr class="bg-dusty-black-200 m-0 h-px grow border-0" />
  </div>
</template>

export default HRText
